import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {PunkRocker} from "./PunkRocker";
import {GameAssets} from "./GameAssets";
import {PunkGameModuleConfig} from "./PunkGameModuleConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IPunkGameData} from "./server/data/PunkServerData";
import {SoundManager} from "./resource/sound/SoundManager";
import {SoundConfig} from "./SoundConfig";


export class PunkRockerPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "PunkRocker",
            hasActionSpin: true,
            graphics: {backgroundTextureName: GameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: IPunkGameData, bet: number, prevresponse: IPunkGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: parseFloat(response.accumulatedRoundWin),
                    totalSpinWinnings: this.getWin(response, bet, prevresponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false
                }
                // parsedData.isBigWin = this.isBigWin(response.totalSpinWinnings, response.playedBetValue, response.mode);
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SoundManager.playSoundEffect(SoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.playSoundEffect(SoundConfig.instance.AS_WIN_BIG);
        }
    }

    private isBigWin(response: IPunkGameData): boolean {
        const win = parseFloat(response.totalSpinWinnings);
        const playedBetValue = parseFloat(response.playedBetValue);
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (response.wasFeatureBuy) {
            const betPrice = PunkGameModuleConfig.featurePrice.getBuyFeaturePriceAS(response);
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response: IPunkGameData, bet: number, prevData: any): number {
        return parseFloat(response.totalSpinWinnings);
    }

    private getFeatureName(response: IPunkGameData): string {
        const scatterCount: number = this.countScatters(response);
        if ((response.mode === GameMode.NORMAL && response.nextMode === GameMode.FREESPIN) || (response.mode === GameMode.FREESPIN && response.nextMode === GameMode.NORMAL)) {
            return scatterCount === 3 ? "ANARCHY SPINS" : "CIVIL WAR SPINS";
        } else if (response.mode === GameMode.FREESPIN) {
            return scatterCount === 3 ? "ANARCHY SPINS" : "CIVIL WAR SPINS"
        } else if(response.mode===GameMode.RESPIN ||response.nextMode===GameMode.RESPIN){
            return "RIOT RESPIN";

        }else {
            return response.mode;
        }
    }

    private countScatters(response: IPunkGameData): number {
        let returnVal: number = 0;
        if (response.scatterPositions) {
            for (let idx: number = 0; idx < response.scatterPositions.length; idx++) {
                if (response.scatterPositions[idx] > -1) {
                    returnVal++;
                }
            }
        }
        return returnVal;
    }

    private isFreeSpinTriggered(response: IPunkGameData): boolean {
        return (response.freespinTriggeredThisSpin != null ? response.freespinTriggeredThisSpin : false);
    }

    private isRoundComplete(response: IPunkGameData): boolean {
        return ([GameMode.NORMAL, GameMode.FREESPIN].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IPunkGameData): boolean {
        return response.mode === GameMode.FREESPIN && response.nextMode === GameMode.NORMAL;
    }

}